import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/rahreivee/emagyl.ro/components/footers/Footer1.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/rahreivee/emagyl.ro/components/headers/Header4.jsx");
;
import(/* webpackMode: "eager" */ "/home/rahreivee/emagyl.ro/node_modules/next/dist/client/link.js");
